// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.downtimeIndicatorsContainer__Sw6iL {
  max-width: 550px;
}

.downtimeIndicatorsTitle__Joqx0 {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  margin-bottom: 25px;
  display: block;
}

.indicatorsContainer__xvywe {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
@media (max-width: 1920px) {
  .indicatorsContainer__xvywe {
    gap: 10px;
    margin-bottom: 10px;
  }
}

.indicator__vMUoD {
  color: var(--inputs-filled-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  gap: 5px;
  align-items: flex-start;
  justify-content: flex-start;
}
@media (max-width: 1920px) {
  .indicator__vMUoD svg {
    width: 21px;
  }
}
@media (max-width: 1440px) {
  .indicator__vMUoD {
    flex-wrap: wrap;
  }
}

.indicatorIcon__rUNNJ {
  fill: var(--buttons-disable);
}

.diagnosticPointsText__FJEEk {
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsTemperature/components/DowntimeIndicators/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAzEF;AA0EE;EAJF;IAKI,SAAA;IACA,mBAAA;EAvEF;AACF;;AA0EA;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,2BAAA;AAvEF;AAyEE;EACE;IACE,WAAA;EAvEJ;AACF;AA0EE;EAjBF;IAkBI,eAAA;EAvEF;AACF;;AA0EA;EACE,4BAAA;AAvEF;;AA0EA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.downtimeIndicatorsContainer {\n  max-width: 550px;\n}\n\n.downtimeIndicatorsTitle {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-bottom: 25px;\n  display: block;\n}\n\n.indicatorsContainer {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  @media (max-width: 1920px) {\n    gap: 10px;\n    margin-bottom: 10px;\n  }\n}\n\n.indicator {\n  color: var(--inputs-filled-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  display: flex;\n  gap: 5px;\n  align-items: flex-start;\n  justify-content: flex-start;\n\n  @media (max-width: 1920px) {\n    svg {\n      width: 21px;\n    }\n  }\n\n  @media (max-width: 1440px) {\n    flex-wrap: wrap;\n  }\n}\n\n.indicatorIcon {\n  fill: var(--buttons-disable);\n}\n\n.diagnosticPointsText {\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"downtimeIndicatorsContainer": `downtimeIndicatorsContainer__Sw6iL`,
	"downtimeIndicatorsTitle": `downtimeIndicatorsTitle__Joqx0`,
	"indicatorsContainer": `indicatorsContainer__xvywe`,
	"indicator": `indicator__vMUoD`,
	"indicatorIcon": `indicatorIcon__rUNNJ`,
	"diagnosticPointsText": `diagnosticPointsText__FJEEk`
};
module.exports = ___CSS_LOADER_EXPORT___;
